import Flex from '@talkdesk/cobalt-react-flex'
import context from '../../config/context'
import {
  Center,
  NavbarMenu,
  TalkdeskFooter,
  TalkdeskNavbar,
} from '../../components'
import { useInitialization } from '../../contexts/Initialization'
import { computeShouldSetupMFA } from '../../hooks/useAppInit'

const Base = ({ navbarActionElement, pageHeader, children }) => (
  <Flex direction='column' width='100vw' height='100vh'>
    <TalkdeskNavbar actionElement={navbarActionElement} />
    {pageHeader}
    <Flex direction='column' width='100%' grow scrollable>
      {children}
    </Flex>
    <TalkdeskFooter showGoogleFooterLink={context.showGoogleFooterLink} />
  </Flex>
)

const Centered = ({ children, ...props }) => (
  <Base {...props}>
    <Center>{children}</Center>
  </Base>
)

Base.Centered = Centered

export default Base

export const withCenteredBaseWithMenu = (WrappedComponent) => {
  const CenteredBaseWithMenu = (props) => {
    const rest = { ...props }
    delete rest.user
    delete rest.displayLogoutMenuOnly
    const { user } = useInitialization() || {}
    const shouldSetupMFA = computeShouldSetupMFA(user)

    return (
      <Base.Centered
        navbarActionElement={
          <NavbarMenu
            name={user?.name ?? ''}
            email={user?.email ?? ''}
            displayLogoutMenuOnly={shouldSetupMFA}
          />
        }
      >
        <WrappedComponent {...rest} />
      </Base.Centered>
    )
  }

  return CenteredBaseWithMenu
}

export const withBaseWithMenu = (WrappedComponent, BaseHeader) => {
  const WithBaseWithMenu = (props) => {
    const rest = { ...props }
    delete rest.user
    const { user } = useInitialization() || {}

    return (
      <Base
        navbarActionElement={
          <NavbarMenu name={user?.name ?? ''} email={user?.email ?? ''} />
        }
        pageHeader={BaseHeader ? <BaseHeader /> : null}
      >
        <WrappedComponent {...rest} />
      </Base>
    )
  }

  return WithBaseWithMenu
}
